import Vue from 'vue';
import Vuex from 'vuex';
import { state, mutations } from './mutations.js';
import * as actions from './actions';
import * as getters from './getters';
import Alert from './alert.js';

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    Alert,
  },
});

export default store;
